// GalleryMediaGrid.jsx

import React from 'react';

// CSS
import './GalleryMediaGrid.css';

// Components
import Grid from 'node/grid/Grid';

/**
 * GalleryMediaGrid
 *
 * Staggered column gallery for photos and videos. Cards keep each
 * media item's native aspect ratio instead of stretching to a uniform cell.
 *
 * @returns {ReactNode} The rendered component.
 */
const GalleryMediaGrid = React.memo(({
    containerRef,
    theme,
    displayedNodes,
    gap,
    minCols,
    maxCols,
    colWidth,
    handleCardClick,
    handleCardDoubleClick,
    handleCardDragStart = null,
    renderCard,
    renderCardOverlay,
    hasMore,
    loadMoreRef,
}) => {

  // ----- RENDER ----- //

  return (
        <div
          className="gallery-view-container"
          style={{
                '--gallery-badge-foreground': theme.highlightForeground || theme.foreground,
                '--gallery-media-fallback-color': theme.foregroundMuted,
                '--gallery-overlay': theme.overlay,
            }}
          ref={containerRef}
        >
            <Grid
              items={displayedNodes}
              gap={`${gap}px`}
              minCols={minCols}
              maxCols={maxCols}
              colWidth={colWidth}
              renderItem={(item) => (
                    <div
                      className="gallery-view-card gallery-view-card--media"
                      style={{
                            backgroundColor: theme.backgroundMuted,
                            borderColor: theme.backgroundMuted,
                        }}
                      key={item?.key}
                      draggable={Boolean(handleCardDragStart && item?.key)}
                      onDragStart={handleCardDragStart
                        ? (event) => handleCardDragStart(event, item)
                        : undefined}
                      onClick={(event) => handleCardClick(event, item)}
                      onDoubleClick={(event) => handleCardDoubleClick(event, item)}
                    >
                        {renderCardOverlay?.(item)}
                        {renderCard(item)}
                    </div>
                )}
            />

            {hasMore && (
                <div className="gallery-view-load-more" ref={loadMoreRef} />
            )}
        </div>
    );
});

// Dev Tools
GalleryMediaGrid.displayName = 'GalleryMediaGrid';

export default GalleryMediaGrid;
